import { useState } from 'react';
import type { BookStatus } from '../../../types/manageBooks';
import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
  open: boolean;
  count: number;
  onCancel: () => void;
  onConfirm: (status: BookStatus) => void;
  busy: boolean;
}

export function BookStatusChangeDialog({ open, count, onCancel, onConfirm, busy }: Props) {
  const { t } = useTranslation();
  const [status, setStatus] = useState<BookStatus>(2 /* Published */);
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      role="dialog" aria-modal="true" aria-labelledby="status-dialog-title"
    >
      <div className="bg-white rounded shadow-lg p-5 max-w-md w-full">
        <h2 id="status-dialog-title" className="text-lg font-semibold mb-3">
          {t('App.Admin.Books.BookStatusChangeDialog.Title', { count })}
        </h2>
        <label className="flex flex-col text-sm mb-4">
          <span className="text-neutral-700">{t('App.Admin.Books.BookStatusChangeDialog.NewStatusLabel')}</span>
          <select
            value={status}
            onChange={e => setStatus(Number(e.target.value) as BookStatus)}
            className="border rounded px-3 py-2 min-h-[44px]"
          >
            <option value={1}>{t('App.Common.BookStatus.Draft')}</option>
            <option value={2}>{t('App.Common.BookStatus.Published')}</option>
            <option value={3}>{t('App.Common.BookStatus.Archived')}</option>
          </select>
        </label>
        <div className="flex justify-end gap-2">
          <button
            type="button" onClick={onCancel}
            className="px-4 py-2 border rounded min-h-[44px]"
          >{t('App.Admin.Books.BookStatusChangeDialog.Cancel')}</button>
          <button
            type="button" onClick={() => onConfirm(status)} disabled={busy}
            className="px-4 py-2 bg-primary-600 text-white rounded disabled:opacity-50 min-h-[44px]"
          >
            {busy ? t('App.Admin.Books.BookStatusChangeDialog.Updating') : t('App.Admin.Books.BookStatusChangeDialog.Apply')}
          </button>
        </div>
      </div>
    </div>
  );
}
